import { Routes, Route } from 'react-router-dom';
import GetQuotePage from './GetQuotePage/GetQuotePage';
import EngagementsPage from './Engagements/EngagementsPage';
import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import BookAMeetingPage from './BookAMeetingPage';

export const ConveyancingRoutes = () => {
  return (
    <ContainerWrapper>
      <Routes>
        <Route path="/quote" element={<GetQuotePage />} />
        <Route path="engagements" element={<EngagementsPage />} />
        <Route path="book-meeting" element={<BookAMeetingPage />} />
      </Routes>
    </ContainerWrapper>
  );
};
